import React from "react";
import { createRoot } from "react-dom/client";
export function rootWithComponent(element, Component, props) {
    const root = createRoot(element);
    root.render(React.createElement(Component, { ...props }));
    return root;
}
export * from "./current-from-max-display";
//# sourceMappingURL=index.js.map